import React from 'react'

import __uniqueId from 'lodash/uniqueId'

export default function useUniqueId(prefix: string, id?: string) {
  const ref = React.useRef(id ? `${prefix}-${id}` : __uniqueId(prefix))
  return ref.current
}
